import { alphaNumbericUnderscoreRegex } from "@mltask/core/Utils/RegexHelper";
import dynamic from "next/dynamic";
import React, { useState } from "react";
import { useForm } from "react-hook-form";

const SimpleTextInput = dynamic(
  () => import("@/components/ui/Input/SimpleTextInput"),
  {
    ssr: false,
  }
);
type Props = { loading: boolean; tryUsername: (username: string) => void };

export default function CreateUsername({ loading, tryUsername }: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [chosenUsername, setChosenUsername] = useState("");
  const loadingStyle = "loading-md loading loading-dots text-secondary";

  return (
    <div className="inset-0 mx-auto mt-4 flex flex-row overflow-y-auto rounded-xl ">
      <form
        id="usernamecreationform"
        className="mx-auto flex w-full flex-col space-y-4  font-bold"
        noValidate
        onSubmit={handleSubmit((data) => {
          // setConsentModalOpen(true);
          tryUsername(chosenUsername);
        })}
      >
        <div className="flex w-full flex-col text-secondary-content">
          <SimpleTextInput
            registrar={register("username", {
              required: true,
              pattern: alphaNumbericUnderscoreRegex(3),
              onChange: (e) => {
                setChosenUsername(e.target.value);
              },
            })}
            errorSection={
              errors["username"] && (
                <div className="mt-5 flex items-center rounded-md bg-secondary-content p-2">
                  <span className="text-error">
                    Invalid Username (Min length 3, can only contain letters,
                    numbers, and underscores.)
                  </span>
                </div>
              )
            }
            inputType="text"
            placeholder="preferably the same as your X's handle"
            value={chosenUsername}
            pathD="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
          />

          {/* <input
            {...register("username", {
              required: true,
              pattern: Constants.alphaNumbericUnderscoreRegex(3),
              onChange: (e) => {
                setChosenUsername(e.target.value);
              },
            })}
            type="text"
            placeholder="value"
            className="input flex w-full"
            value={chosenUsername}
          /> */}
        </div>
        <button
          type="submit"
          disabled={chosenUsername.length < 3}
          className={`btn btn-success mt-10 w-full ${
            loading ? "btn-disabled" : ""
          }`}
          onClick={() => {}}
        >
          {loading && <span className={`${loadingStyle} `}></span>}
          Submit
        </button>
      </form>
    </div>
  );
}
